// src/store/thunks/sixCatalog/toggleFilterAndFetchThunk.ts

import type { CatalogFilterKey } from '@/types/Sixes';
import { toggleFilter } from '@/store/slices/sixCatalog/sixCatalogSlice';
import { fetchSixCatalogThunk } from '@/store/thunks/sixCatalog/fetchSixCatalog';
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';

/**
 * Toggles a catalog filter and fetches the updated catalog.
 * This thunk first toggles the filter in state, then dispatches
 * fetchSixCatalog with the updated filters and current search.
 */
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type -- void
export const toggleFilterAndFetchThunk = createAppAsyncThunk<void, CatalogFilterKey>(
  'catalog/toggleFilterAndFetch',
  async(filterKey, { dispatch, getState }) => {
    // Toggle the filter in state
    dispatch(toggleFilter(filterKey));

    // Get updated state after toggle
    const state = getState();
    const { filters, search, sortField, sortDirection } = state.sixCatalog;

    // Fetch catalog with updated filters
    await dispatch(
      fetchSixCatalogThunk({
        filters,
        search,
        sortField,
        sortDirection,
      })
    );
  }
);
